
export class FlightsInfoModule {
  constructor (
    public departingCity: string,
    public arrivalCity: string,
    public departionDate:any,
  ) { }
 }
